"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataValidationError = void 0;
class DataValidationError extends Error {
    constructor(message, baseError) {
        super(message);
        this.baseError = baseError;
    }
}
exports.DataValidationError = DataValidationError;
//# sourceMappingURL=DataValidationError.js.map